import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { ErrorPage } from './error-page';

export default function PageNotFound() {
    return (
        <ErrorPage
            code="404"
            title="Página não encontrada"
            message="Não encontramos a página que você está procurando. Verifique se o endereço foi digitado corretamente."
            icon={<ErrorOutlineIcon />}
            color="error"
            showBack
        />
    );
}
